import firebase from "firebase/app";

import { Card } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import updateExportPreset from "astrid-firestore/src/api/exports/updateExportPreset";
import { Pipeline } from "astrid-firestore/src/api/pipelines/types/Pipeline";

import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";

import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";
import PipelineSteps from "../../../pipelines/components/PipelineForm/components/PipelineSteps";

export default function ExportPresetForm({ exportPreset }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: Pipeline,
		defaultValues: {
			name: exportPreset.name || "",
			steps: exportPreset.steps || null,
		},
		onSubmit: ({ name, steps }) => {
			return updateExportPreset(firebase, {
				ref: exportPreset.ref,
				name,
				steps,
			});
		},
	});

	const { formState, onSubmit } = form;

	return (
		<>
			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Input name="name" label={t("name", "Name")} />

						<PipelineSteps name="steps" label={t("steps", "Steps")} />
					</Form>
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
